import { ROWS_PER_PAGE, UserParams, UserTableSelection } from '@Types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StylovyzeTableFooter } from '@innovyze/stylovyze';
import { getUsers } from '@Actions/users';
import { getValue } from '@Selectors';

interface Props {
	userTableSelection: UserTableSelection;
	selectedLimitIndex: number;
	setSelectedLimitIndex: React.Dispatch<React.SetStateAction<number>>;
	createGetUsersRequest: (
		userTableSelectionState: UserTableSelection,
	) => UserParams;
}

export default function EntitlementsTableFooter({
	userTableSelection,
	selectedLimitIndex,
	setSelectedLimitIndex,
	createGetUsersRequest,
}: Props): React.ReactElement {
	const dispatch = useDispatch();
	const {
		paginatedUsers: { pagination },
	} = useSelector(getValue).users;
	const { pages } = pagination;
	const [currentPage, setCurrentPage] = useState(1);

	return (
		<StylovyzeTableFooter
			rowsPerPage={{
				options: ROWS_PER_PAGE.map((name, index) => ({
					name: name.toString(),
					onClick: () => {
						setSelectedLimitIndex(index);
						const getUsersRequest =
							createGetUsersRequest(userTableSelection);
						dispatch(
							getUsers({
								...getUsersRequest,
								pageSize: ROWS_PER_PAGE[index],
								page: 1,
							}),
						);
					},
				})),
				selectedIndex: selectedLimitIndex,
			}}
			pagination={{
				totalNumberOfPages: pages,
				currentPage,
				dataCy: 'pagination-01',
				onChange: (_, page) => {
					setCurrentPage(page);
					const getUsersRequest =
						createGetUsersRequest(userTableSelection);
					dispatch(
						getUsers({
							...getUsersRequest,
							pageSize: ROWS_PER_PAGE[selectedLimitIndex],
							page: page,
						}),
					);
				},
			}}
		/>
	);
}
